const roqqnrollRouteNames = {
  roqqnrollIndex: '/gamefi/roqqnroll',
  roqqnrollBreak: '/gamefi/roqqnroll/break-time',
  testPage: '/roqqnroll',
};

export default roqqnrollRouteNames;
